import React from 'react';

const DropdownItemTypeSelector: React.FC<DropdownItemTypeSelectorProps> = (props) => (<>{props?.children}</>);

interface DropdownItemTypeSelectorProps {
    type: string;
}

export default DropdownItemTypeSelector;